import PillButton from 'components/buttons/PillButton';
import PillButtonText from 'components/text/PillButtonText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ToggleButton: FunctionComponent<Props> = ({
    className = '',
    isActive = false,
    isDisabled = false,
    onClick,
    testId = TEST_ID,
    text
}) => {
    const activeClass = isActive ? styles.active : '';

    return (
        <PillButton
            ariaPressed={isActive}
            className={`${activeClass} ${styles.toggleButton} ${className}`}
            isDisabled={isDisabled}
            onClick={onClick}
            testId={testId}>
            <PillButtonText text={text} />
        </PillButton>
    );
};

export default ToggleButton;
